import Vue from 'vue'

export const userKey = '__ofedl_user'
export const baseApiUrl = process.env.VUE_APP_API

export function showError(e){
    if(e && e.response && e.response.data){
        Vue.toasted.global.defaultError({msg : e.response.data})
    } else if(typeof e === "string"){
        Vue.toasted.global.defaultError({msg : e})
    } else {
        
        Vue.toasted.global.defaultError()
    }
}

export function showSuccess(e){
    if(e && e.response && e.response.data){
        Vue.toasted.global.defaultSuccess({msg : e.response.data})
    } else if(typeof e === "string"){
        Vue.toasted.global.defaultSuccess({msg : e})
    } else {
        Vue.toasted.global.defaultSuccess()
    }
}


export default {baseApiUrl, showError, showSuccess, userKey}